import {startPortal} from './portal-startup';

void startPortal(() => import('./bootstrap').then(module => module.bootstrapPortal()));
